import { __decorate } from "tslib";
import { Component, useModule, Vue } from "@/types";
import "@/assets/scss/layouts/layoutDefault.scss";
import { Header, LeftMenu } from "@/components";
let LayoutDefault = class LayoutDefault extends Vue {
    constructor() {
        super(...arguments);
        this.store = useModule(this.$store);
    }
    get setCurrentRoute() {
        return () => {
            return import(`@/views/${this.getParentRoute}/${this.getChildRoute}/${this.getChildRoute}.vue`);
        };
    }
    get getParentRoute() {
        return this.$route.matched[0].name;
    }
    get getChildRoute() {
        return this.$route.name;
    }
    menuChangeHandler() {
        this.store.menuModule.changeMenu();
    }
    /**
     * Избравиться от глобальных сущностей стора
     */
    beforeDestroy() {
        if (this.store.dialog.curr) {
            this.store.dialog.removeDialog();
        }
        if (this.store.tableRow.current) {
            this.store.tableRow.setCurrentRow(null);
        }
    }
};
LayoutDefault = __decorate([
    Component({
        components: {
            LeftMenu,
            Header,
        },
    })
], LayoutDefault);
export default LayoutDefault;
